import * as React from "react";

const SvgFastclock = (props) => (
  <svg
    className="fastclock_svg__fastclock"
    viewBox="0 0 649 548"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10,
    }}
    {...props}
  >
    <path
      d="M0-6.606 11.008 4.402l17.611-15.41"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "5.2px",
      }}
      transform="translate(329.019 264.815) scale(4.16667)"
    />
    <path
      d="M-3.302-3.302h6.604"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "4.4px",
        strokeLinecap: "round",
      }}
      transform="matrix(0 4.16667 4.16667 0 388.643 159.034)"
    />
    <path
      d="M-3.302 3.302h6.604"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "4.4px",
        strokeLinecap: "round",
      }}
      transform="scale(4.16667) rotate(-90 93.31 .035)"
    />
    <path
      d="M-6.604 0H0"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "4.4px",
        strokeLinecap: "round",
      }}
      transform="matrix(-4.16667 0 0 4.16667 476.075 273.985)"
    />
    <path
      d="M0 0h30.82"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "5.2px",
        strokeLinecap: "round",
      }}
      transform="translate(108.874 273.985) scale(4.16667)"
    />
    <path
      d="M0 0h30.821"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "5.2px",
        strokeLinecap: "round",
      }}
      transform="translate(145.564 218.95) scale(4.16667)"
    />
    <path
      d="M0 0h28.619"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "5.2px",
        strokeLinecap: "round",
      }}
      transform="translate(154.739 319.845) scale(4.16667)"
    />
    <path
      d="M26.919-60.033C13.639-56.494 2.574-46.135-1.207-31.9c-5.618 21.151 6.974 42.853 28.126 48.471 21.152 5.618 42.853-6.975 48.471-28.126 3.964-14.924-1.137-30.122-11.915-39.75"
      style={{
        fill: "none",
        fillRule: "nonzero",
        stroke: "#000",
        strokeWidth: "5.2px",
      }}
      transform="scale(-4.16667 4.16667) rotate(75.125 -83.317 -60.595)"
    />
  </svg>
);

export default SvgFastclock;
